module.exports = __webpack_public_path__ + "img/no-matching-results.ec854158.svg";